import { DEFAULT_COLORS } from '../../colors';
import { globalData } from '../..';
import { assetUrl, pushToDataLayer, returnUrl } from '../../env';
import { bubbleClick } from '../bubble';


const chatHeader = () => {
    //MAIN HEADER
    const header = document.createElement("div");
    header.id = 'chatheadHeader'

    if (DEFAULT_COLORS['headerBackgroundColor']) {
        header.style.backgroundColor = DEFAULT_COLORS['headerBackgroundColor']
    }

    //HEADER WRAPPER
    const headerWrapper = document.createElement("div");
    headerWrapper.classList.add('chatheadHeaderWrapper');

    //ONLY ADD THE HEADER IMAGE AND LINK IF THE HEADER IMAGE EXISTS
    if (globalData?.headerImage) {
        //HEADER LINK A DIV
        const headerLink = document.createElement("a");
        headerLink.classList.add('chatheadHeaderLink');
        returnUrl(headerLink);

        //HEADER IMAGE
        const headerImg = document.createElement("img");
        headerImg.src = assetUrl(globalData?.headerImage);
        headerLink.append(headerImg)
        headerWrapper.append(headerLink)
    }

    //APPEND THE CONTENT TO THE HEADER
    headerWrapper.append(closeButton())
    header.append(headerWrapper)

    return header
}

const closeButton = () => {

    const { closeIconBackgroundColor, bodyBackgroundColor } = DEFAULT_COLORS;

    const close = document.createElement("div");
    close.id = 'chatheadCloseButton'
    close.style.backgroundColor = closeIconBackgroundColor;
    close.addEventListener("click", bubbleClick)
    close.addEventListener("click", () => {
        pushToDataLayer({
            eventCategory: 'homepage',
            eventLabel: 'chat head close button'
        })
    })
    const svg = `
        <svg
            x="0px"
            y="0px"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 47.971 47.971"
        >
            <path
            fill=${bodyBackgroundColor}
            d="M28.228,23.986L47.092,5.122c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0L23.986,19.744L5.121,0.88
                        c-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l18.865,18.864L0.879,42.85c-1.172,1.171-1.172,3.071,0,4.242
                        C1.465,47.677,2.233,47.97,3,47.97s1.535-0.293,2.121-0.879l18.865-18.864L42.85,47.091c0.586,0.586,1.354,0.879,2.121,0.879
                        s1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L28.228,23.986z"
            />
        </svg>`

    close.innerHTML = svg;

    return close

}

export default chatHeader